import { render, staticRenderFns } from "./KLine.vue?vue&type=template&id=8b685504&scoped=true&"
import script from "./KLine.vue?vue&type=script&lang=js&"
export * from "./KLine.vue?vue&type=script&lang=js&"
import style0 from "./KLine.vue?vue&type=style&index=0&id=8b685504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b685504",
  null
  
)

export default component.exports